import CtaButtonTw from '@components/buttons/ctaButtonTw'
import Polaroid1 from '@components/imageModules/v5/polaroid1'
import { GATSBYIMGLOADING } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { IGatsbyImageDataArray } from '@et/types/ImageTypes'
import { classNames } from '@utils/genUtils'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { ReactNode } from 'react'
import WhatYoullLearnItemV5 from './whatYoullLearnItemV5'
export enum WYLItemEnums {
  TYPE1 = 'type1',
  TYPE2 = 'type2',

}
export interface IWYLItem {
  title: string,
  desc: string,
  image?: IGatsbyImageDataObject,
  imageOnly?: {
    image: IGatsbyImageDataObject,
    classes?: string,
    type: WYLItemEnums
  },
  className?: string,
  bg?: {
    classes?: string,
    image: IGatsbyImageDataObject
  }
}

interface Props {
  frameImage?: boolean
  titleImage: IGatsbyImageDataObject
  title: string
  subTitle: string
  subTitleClasses?: string
  titleClasses?: string
  textBottom?: boolean
  items: IWYLItem[]
  itemClasses?: {
    titleClasses: string
    textClasses: string
  }
  cta?: ReactNode
}

function WhatYoullLearnV5(props: Props) {
  const { frameImage = true, titleImage, title, subTitle, titleClasses, subTitleClasses, items, itemClasses, cta, textBottom = false } = props
  //md:max-w-[879px] 
  return (
    <div className='mx-auto et-fluid-grid et-fluid-grid-alt max-w-[375px] md:px-5 md:py-20 md:max-w-[1200px] lg:pt-24 lg:pb-28'>

      {/* POLAROID IMAGE */}
      <div className='hidden col-span-2 col-start-2 md:flex md:col-start-1 md:col-span-6 md:row-start-1 md:row-span-2 lg:col-start-1 lg:col-span-4'>
        <Polaroid1 image={titleImage} frame={frameImage} />
      </div>

      {/* HEADLINE */}
      <div className='col-span-2 col-start-2 py-8 pr-4 wyl-title md:col-start-7 md:col-span-6 md:row-start-1 md:px-4 md:py-0 lg:pb-14 lg:col-start-5 lg:col-span-7'>
        <span className={classNames(subTitleClasses ? subTitleClasses : 'text-grey-600', 'text-lg')}>
          {subTitle}
        </span>
        <h2 className={classNames(titleClasses ? titleClasses : 'text-grey-800', 'font-sentinel__SemiBoldItal text-5xl lg:mt-4 lg:text-6xl xxl:text-7xl')}>
          {title}
        </h2>
      </div>

      {items.map((item, index) => {
        const isLastItem = index === items.length - 3 // 3 accounts for the blank 2 items

        return (<WhatYoullLearnItemV5
          key={index}
          index={index}
          item={item}
          itemClasses={itemClasses}
          frameImage={frameImage}
          textBottom={textBottom}
          isLastItem={isLastItem}
        />)
      })}

      {cta && <div className='flex col-span-2 col-start-2 cta-wrapper md:col-start-7 md:col-span-6 lg:col-start-1 lg:col-span-12'>
        {cta}
      </div>}

    </div>
  )
}

export default WhatYoullLearnV5


export const ExampleCTA = () => {
  const { art } = useStaticQuery(
    graphql`
        query {
            art: imgixImage(url: "procreate701/ff-hero-flowers-min.png") {
                gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, imgixParams: {})
            }
        }`)
  return (
    <div className='relative text-white flex bg-[#191E01] py-[65px] px-10 items-center flex-col overflow-hidden md:py-[78px] lg:flex-row lg:justify-between lg:py-16 lg:flex-1'>
      <div className='relative z-2 mb-8 text-2xl font-sentinel__SemiBoldItal text-center lg:text-left lg:max-w-[600px] lg:mb-0'>
        This course is pre-recorded with lifetime access, so you can watch it whenever it works best with your schedule and as many times as you’d like.
      </div>

      <div className='relative z-2'>
        <CtaButtonTw
          className='btn-ff-peach-300 btn-lg'
          id='checkout-card'
          text='Enroll Now!' />
      </div>

      <div className='absolute top-0 right-0 w-[1000px] z-1'>
        <GatsbyImage
          image={art.gatsbyImageData}
          loading={GATSBYIMGLOADING.LAZY}
          alt={'Teela\'s iPad Pro'} />
      </div>
    </div>
  )
}
